import React from "react";
import { NumericFormat } from "react-number-format";
import TextField from "@mui/material/TextField";

const MoneyInput = ({
  value,
  setValue,
  label = "", // Label prop
  required = false,
  width = "100%",
  disabled = false,
  marginBottom = 0, // New marginBottom prop
}) => {
  return (
    <NumericFormat
      style={{ width: width, marginBottom: marginBottom }}
      disabled={disabled}
      value={value}
      customInput={TextField}
      thousandSeparator="."
      decimalSeparator=","
      prefix="R$"
      allowLeadingZeros={false}
      placeholder={"R$0,00"}
      decimalScale={2}
      fixedDecimalScale
      allowNegative={false}
      onValueChange={(values) => {
        setValue(values.floatValue || 0);
      }}
      isNumericString
      required={required}
      label={label}
    />
  );
};

export default MoneyInput;
